import { Button, Form, Input } from "antd";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AuthenticationState } from "../../../interfaces/users";
import { useState } from "react";
import { api } from "../../../config";
import { onChangeCurrencyInput } from "../../Kanban/SingleTicketModal";
import { AddonsTable } from "./AddonsTable";

interface AddonsFormProps {
  ticketId: number;
  ticketAdditions: any;
  refetch?: () => void
}

type FieldType = {
  description?: string;
  value?: number;
};

export const AddonsForm = ({
  ticketId,
  ticketAdditions,
  refetch
}: AddonsFormProps) => {
  const { token } = useSelector((state: AuthenticationState) => state);
  const [additions, setAdditions] = useState<any[]>(ticketAdditions);
  const [value, setValue] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const onFinish = (ticketId: number, values: any) => {
    if (!description || !value) {
      toast.error("Preencha todos os campos");
      return;
    }
    setLoading(true);
    api(token)
      .post(`payment/additions`, {
        fieldReportId: ticketId,
        description,
        value: Number(value.replace(",", ".")),
        status: "PENDING_APPROVEMENT",
      })
      .then((response) => {
        const additonal = {
          id: response.id,
          description,
          value: response.value,
          status: "PENDING_APPROVEMENT",
        };
        setDescription("");
        setValue("");
        refetch?.()
        setAdditions((prev) => [...prev, additonal]);
      })
      .catch((error) => {
        console.error(error);
        toast.error(error.response);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="flex flex-col gap-5 mt-4">
      <b>Adicionais</b>
      <div>
        <Form
          className="flex gap-2 w-64"
          name="basic"
          onFinish={(values) => onFinish(ticketId, values)}
          onFinishFailed={() => {
            toast.error("Erro ao adicionar");
          }}
          autoComplete="off"
        >
          <Input
            className="min-w-24"
            style={{ width: "60%" }}
            type="text"
            onChange={(value) => setDescription(value.target.value)}
            value={description}
          />
          <Input
            className="min-w-24"
            style={{ width: "60%" }}
            prefix="R$"
            onChange={(value) =>
              onChangeCurrencyInput(value.target.value, setValue, 6) ?? ""
            }
            value={value}
            placeholder="0,00"
          />
          <Button loading={loading} type="primary" htmlType="submit">
            Adicionar
          </Button>
        </Form>
      </div>
      <AddonsTable refetch={refetch} setAdditions={setAdditions} ticketId={ticketId} paymentAdditions={additions}   />
    </div>
  );
};

export const statusDict = {
  PENDING_APPROVEMENT: "Pendente de Aprovação",
  REJECTED: "Rejeitado",
  APPROVED: "Aprovado",
};
